<template lang="pug">
#app(v-if='translationsAreLoaded' :class='{ inlined: isInlined }')
    //- merchant portal app shell: a #f8f8f8 frame, the page on a white canvas next to the nav
    v-app(:class="{ 'dd-shell--flush': !canvasLeft }" :style="{ '--dd-canvas-left': canvasLeft + 'px' }")
        template(v-if="isRestaurantAdmin && isLoggedIn")
            notification-alert        
            manage-orders
        component(:is="$router.currentRoute.meta.layout ? $router.currentRoute.meta.layout : 'ordit-layout'")
            transition(name='fade' mode='out-in')
                v-main
                    //- the merchant portal's centred page column (_theme.scss .dd-page)
                    v-container.dd-page(fluid)

                        //v-btn(v-if="!isRestaurantAdmin" @click="testMessaging") Test
                        //v-btn(v-if="!isRestaurantAdmin" @click="testApprove") Test approve

                        router-view
    intercom
div(v-else)
    .app-loading-cont
        v-progress-circular(:size="50" color="primary" indeterminate)


</template>

<script>
import { mapGetters } from 'vuex'
import configType from '@/store/type/configType'
import authType from '@/store/type/authType'
import Intercom from '@/components/elements/Intercom'

export default {
    name: 'App',
    components: {
        Intercom,
        // restaurant-admin only: kept out of the entry bundle
        NotificationAlert: () =>
            import(
                /* webpackChunkName: "restaurant-admin" */ '@/components/pages/restaurants/NotificationAlert'
            ),
        ManageOrders: () =>
            import(
                /* webpackChunkName: "restaurant-admin" */ '@/components/pages/restaurantAdmin/confirm/ManageOrders'
            ),
    },
    computed: {
        ...mapGetters({
            isInlined: configType.getters.INLINED,
            translationsAreLoaded: configType.getters.TRANSLATIONS_ARE_LOADED,
            isLoggedIn: authType.getters.IS_LOGGED_IN,
            isRestaurantAdmin: authType.getters.IS_RESTAURANT_ADMIN,
        }),
        // width of the permanent nav (0 on phones and on pages without it)
        canvasLeft() {
            return this.$vuetify.application.left
        },
    },
    // methods: {
    //     testMessaging() {
    //         setTimeout(() => {
    //
    //             RestApiCollection.get(RestApiType.NOTIFICATION).test()
    //         }, 5000)
    //     },
    //     testApprove() {
    //         setTimeout(() => {
    //
    //             RestApiCollection.get(RestApiType.NOTIFICATION).testApprove()
    //         }, 5000)
    //     },
    // },
}
</script>

<style lang="scss">
.app-loading-cont {
    width: 55px;
    margin: 0 auto;
    margin-top: 5vh;
}
.v-main {
    min-height: 100vh;
}
</style>
